import React from "react";
import PartnerList from "components/Partners";

const Partners = () => <PartnerList />;

export default Partners;
